const appPageNavBarWidth = '10%';
const appPageTabsWidth = '90%';

export const customizedThemes = {
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  palette: {
    primary: {
      main: '#e0592a',
      light: '#f9ded4',
      background: '#fbfbfb',
      pageMainBackgroundGrey: '#f3f3f3',
      black: '#000000',
      white: '#ffffff',
      grey: '#8f8f8f',
    },
  },
  typography: {
    fontFamily: 'Lato',
    useNextVariants: true,
  },
  overrides: {
    MuiOutlinedInput: {
      root: {
        '& fieldset': {
          borderRadius: '0',
        },
      },
    },
    MuiTableRow: {
      hover: {
        '&:hover': {
          background: '#d0d0d045 !important',
        },
      },
    },
    MuiTabs: {
      root: {
        width: '100%',
        marginLeft: '2%',
      },
    },
  },
};

export const appPageStyles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
    width: '100%',
    backgroundColor: customizedThemes.palette.primary.background,
    position: 'fixed',
    overflow: 'auto',
  },
  tabs: {
    backgroundColor: customizedThemes.palette.primary.background,
    height: '100%',
    width: appPageTabsWidth,
    flexGrow: '1',
    minWidth: '700px',
    overflow: 'auto',
  },
});

export const versionNumberStyles = theme => ({
  pageContainerWithVersionNumberBelow: {
    height: '100%',
    width: '100%',
    overflow: 'hidden',
  },
  versionNumberContainer: {
    marginLeft: '3%',
    position: 'relative',
    top: '-20px',
  },
  appVersionAndBuildNumber: {
    color: '#000000',
    fontFamily: 'Lato',
    fontSize: '12px',
    fontStyle: 'italic',
    minHeight: '15px',
  },
});

const inputContainerStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'absolute',
  backgroundColor: '#ffffff',
  boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.15)',
};

export const loginPageStyles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    height: '100vh',
    width: '100vw',
    position: 'relative',
    backgroundColor: '#fbfbfb',
    justifyContent: 'center',
  },
  inputContainer: {
    ...inputContainerStyle,
    paddingBottom: '25px',
    width: '40%',
    maxWidth: '500px',
    height: '75%',
    margin: '2.5% 0',
  },
  inputContainerTablet: {
    ...inputContainerStyle,
    paddingBottom: '25px',
    width: '50%',
    margin: '30% 0',
  },
  inputContainerMobile: {
    ...inputContainerStyle,
    paddingBottom: '25px',
    width: '80%',
    margin: '35% 0',
  },
  textBoxContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  welcomeTextBoxMobile: {
    fontFamily: 'circe-rounded',
    fontWeight: 'normal',
    display: 'inline-block',
    color: customizedThemes.palette.primary.black,
    fontSize: '20px',
  },
  craverTextBoxMobile: {
    fontFamily: 'circe-rounded',
    fontWeight: 'bold',
    display: 'inline-block',
    color: customizedThemes.palette.primary.black,
    fontSize: '20px',
  },
  welcomeTextBoxTablet: {
    fontFamily: 'circe-rounded',
    fontWeight: 'normal',
    display: 'inline-block',
    color: customizedThemes.palette.primary.black,
    fontSize: '28px',
  },
  craverTextBoxTablet: {
    fontFamily: 'circe-rounded',
    fontWeight: 'bold',
    display: 'inline-block',
    color: customizedThemes.palette.primary.black,
    fontSize: '28px',
  },
  welcomeTextBox: {
    fontFamily: 'circe-rounded',
    fontWeight: 'normal',
    color: customizedThemes.palette.primary.black,
    fontSize: '34px',
  },
  craverTextBox: {
    fontFamily: 'circe-rounded',
    fontWeight: 'bold',
    color: customizedThemes.palette.primary.black,
    fontSize: '34px',
  },
  backgroundImg: {
    width: '100%',
    height: '100%',
    backgroundSize: 'cover',
  },
  logo: {
    marginBottom: '5%',
    marginTop: '5%',
    width: '80%',
  },
  inputSection: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  textField: {
    width: '80%',
    color: customizedThemes.palette.primary.black,
    marginTop: '5%',
  },
  textFieldTablet: {
    width: '80%',
    color: customizedThemes.palette.primary.black,
    marginTop: '8%',
  },
  textFieldMobile: {
    width: '80%',
    color: customizedThemes.palette.primary.black,
    marginTop: '8%',
  },
  loginBtn: {
    fontFamily: 'Lato',
    fontSize: '12px',
    fontWeight: 'bold',
    color: '#fff',
    width: '80%',
    height: '50px',
    alignSelf: 'center',
    backgroundColor: customizedThemes.palette.primary.main,
    marginTop: '6%',
    borderRadius: 0,
  },
  loginBtnTablet: {
    fontFamily: 'Lato',
    fontSize: '12px',
    fontWeight: 'bold',
    color: '#fff',
    width: '80%',
    height: '40px',
    alignSelf: 'center',
    backgroundColor: customizedThemes.palette.primary.main,
    marginTop: '10%',
    borderRadius: 0,
    boxShadow: '0 0 0 0',
  },
  loginBtnMobile: {
    fontFamily: 'Lato',
    fontSize: '12px',
    fontWeight: 'bold',
    color: '#fff',
    width: '80%',
    height: '40px',
    alignSelf: 'center',
    backgroundColor: customizedThemes.palette.primary.main,
    marginTop: '10%',
    borderRadius: 0,
    boxShadow: '0 0 0 0',
  },
  forgetPassword: {
    width: '80%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: '4%',
  },
  rememberAdminContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  rememberAdminCheckBox: {
    padding: '0 5px 0 0',
  },
  rememberAdminText: {
    fontFamily: 'Lato',
  },
  rememberAdminTextMobile: {
    fontFamily: 'Lato',
    fontSize: '12px',
  },
  forgotPasswordText: {
    textDecoration: 'underline',
    fontFamily: 'Lato',
    fontSize: '14px',
    color: '#000000',
  },
  forgotPasswordTextMobile: {
    textDecoration: 'underline',
    fontFamily: 'Lato',
    fontSize: '12px',
    color: '#000000',
    marginTop: '1.5%',
  },
});

const TITLE_TO_CHART_SPACER = {
  paddingBottom: '3vh',
};
const HOME_PAGE_OUTER_CONTAINER_PADDING_RIGHT = '2vw';
const HOME_PAGE_OUTER_CONTAINER_PADDING_LEFT = '3%';
const HOME_PAGE_OUTER_CONTAINER_PADDING_TOP = '2.5%';

const CHART_HORIZONTAL_WIDTH = '48%';
const CHARTS_MIDDLE_GAP_MARGIN_HALVES = '10px';
export const CHART_PAPER_CONTAINER_PERCENT_HEIGHT = 40;
export const CHART_PAPER_CONTAINER_PERCENT_HEIGHT_MOBILE = 20;
const homePageOuterContainersBase = {
  display: 'flex',
  justifyContent: 'center',
  paddingLeft: HOME_PAGE_OUTER_CONTAINER_PADDING_LEFT,
  paddingRight: HOME_PAGE_OUTER_CONTAINER_PADDING_RIGHT,
};
const verticalChartsContainerBase = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  width: CHART_HORIZONTAL_WIDTH,
  height: '100%',
  minHeight: '200px',
  minWidth: '350px',
};
const chartTitleBase = {
  fontFamily: 'Lato',
  fontWeight: 'bold',
  fontSize: '18px',
  ...TITLE_TO_CHART_SPACER,
};

export const homePageStyles = theme => ({
  timescaleAndChartsFlexColumnDiv: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    backgroundColor: '#fbfbfb',
  },
  timescaleDropdownContainer: {
    ...homePageOuterContainersBase,
    height: '60px',
    paddingTop: HOME_PAGE_OUTER_CONTAINER_PADDING_TOP,
  },
  container: {
    ...homePageOuterContainersBase,
    height: 'calc(98% - 80px)',
  },
  mobileContainer: {
    ...homePageOuterContainersBase,
    flexDirection: 'column',
    justifyContent: 'space-around',
    paddingRight: '3.5%',
  },
  paper: {
    padding: '20px 12px',
    marginBottom: '20px',
    minHeight: `${CHART_PAPER_CONTAINER_PERCENT_HEIGHT}%`,
  },
  mobilePaper: {
    padding: '20px 12px',
    marginBottom: '50px',
    height: '35vh',
  },
  title: chartTitleBase,
  downloadsTitle: {
    ...chartTitleBase,
    paddingBottom: '30px',
  },
  centeredTitle: {
    ...chartTitleBase,
    textAlign: 'center',
    paddingBottom: 0,
    height: centeredTitleHeight,
  },
  leftVerticalChartsContainer: {
    ...verticalChartsContainerBase,
    marginRight: CHARTS_MIDDLE_GAP_MARGIN_HALVES,
  },
  rightVerticalChartsContainer: {
    ...verticalChartsContainerBase,
    marginLeft: CHARTS_MIDDLE_GAP_MARGIN_HALVES,
  },
  chartLikeHorizontalSpacer: {
    width: CHART_HORIZONTAL_WIDTH,
    marginLeft: CHARTS_MIDDLE_GAP_MARGIN_HALVES,
    marginBottom: CHARTS_MIDDLE_GAP_MARGIN_HALVES,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  downloadsTitleAndLegendWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    alignItems: 'baseline',
  },
  twoChartsInOneQuadrantFlexRowDiv: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    height: '100%',
    width: '100%',
  },
  chartElement: {
    height: '100%',
    width: '100%',
    minHeight: '200px',
  },
  halfQuadrantChartElement: {
    height: 'calc(100% - 10px)',
    width: '45%',
    minHeight: '200px',
    minWidth: '160px',
    display: 'flex',
    flexDirection: 'column',
  },
  versionAndBuildNumber: {
    position: 'relative',
    top: '-15px',
  },
  versionAndBuildNumberLikeSpacer: {
    position: 'relative',
    top: '-15px',
    height: '18px',
  },
  relativeParentDivForResizingChart: {
    position: 'relative',
    height: '28vh',
    width: '100%',
  },
  downloadsLegendOuterDiv: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    paddingBottom: '30px',
  },
  downloadsLegendItem: {
    display: 'flex',
    marginRight: '10px',
    alignItems: 'center',
  },
  comingSoonZIndexOverlay: {
    position: 'absolute',
    top: '47%',
    left: '50%',
    zIndex: 5,
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  comingSoonText: {
    fontSize: '30px',
    fontWeight: '600',
    textAlign: 'center',
  },
  comingSoonSubtitle: {
    fontSize: '17px',
    fontStyle: 'italic',
    textAlign: 'center',
  },
});

export const menuBarStyles = theme => ({
  appBar: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '100%',
    width: appPageNavBarWidth,
    padding: '0',
    backgroundColor: customizedThemes.palette.primary.white,
    minWidth: '250px',
  },
  colorGradient: {
    width: '100%',
    background: customizedThemes.palette.primary.white,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '85px',
  },
  menuList: {
    flex: '2',
    width: '100%',
    margin: '0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  menuItem: {
    marginTop: '2px',
    width: '100%',
    padding: '10px 0 10px 0',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  selectedMenuItem: {
    fontcolor: customizedThemes.palette.primary.white,
    backgroundColor: customizedThemes.palette.primary.light,
  },
  subMenuItem: {
    width: '100%',
    padding: '2.5px 0 2.5px 0',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  subMenuListItemText: {
    flex: 1,
    paddingLeft: '70px',
  },
  subMenuMenuListPadding: {
    paddingBottom: '12px',
  },
  subMenuExpandToggleIcon: {
    color: customizedThemes.palette.primary.main,
    fontSize: '17px',
    marginRight: '11px',
  },
  subMenuToggleIcon: {
    color: customizedThemes.palette.primary.black,
    fontSize: '17px',
    marginRight: '11px',
  },
  subMenuListItemTextFlexContainer: {
    flex: 2,
    display: 'flex',
  },
  subMenuExpandToggleFlexContainer: {
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
  },
  drawerOpenListIconContainer: {
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-start',
    marginLeft: '10px',
  },
  drawerClosedListIconContainer: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
  },
  menuItemContainer: {
    width: '100%',
  },
  listItemIcon: {
    color: customizedThemes.palette.primary.black,
    marginLeft: '7.5px',
  },
  listItemIconSelected: {
    color: customizedThemes.palette.primary.main,
    marginLeft: '7.5px',
  },
  listItemText: {
    width: '50px',
    flex: 'none',
    marginLeft: '-7px',
  },
  listItemTypography: {
    color: customizedThemes.palette.primary.black,
    fontSize: '15px',
    fontFamily: 'Lato',
    fontWeight: '600',
  },
  listItemTypographySelected: {
    color: customizedThemes.palette.primary.main,
    fontSize: '15px',
    fontFamily: 'Lato',
    fontWeight: '600',
  },
  subMenuListItemTypography: {
    color: customizedThemes.palette.primary.black,
    fontSize: '15px',
    fontFamily: 'Lato',
    fontWeight: '300',
  },
  subMenuSelectedListItemTypography: {
    color: customizedThemes.palette.primary.black,
    fontSize: '15px',
    fontFamily: 'Lato',
    fontWeight: '600',
  },
  signoutBtn: {
    color: customizedThemes.palette.primary.black,
    fontFamily: 'Lato',
    fontSize: '12px',
    fontStyle: 'italic',
    marginBottom: '35px',
    marginTop: '20px',
  },
  drawerOpenShowLoggedInUser: {
    color: customizedThemes.palette.primary.black,
    fontFamily: 'Lato',
    fontSize: '12px',
    fontStyle: 'italic',
    width: '160px',
    margin: '20px 5px 0 5px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textAlign: 'center',
    minHeight: '15px',
  },
  drawerPaperProps: {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0',
      border: 'none',
      backgroundColor: customizedThemes.palette.primary.white,
    },
  },
  expandOrCollapseButton: {
    color: '#9a9a9a',
    border: '2px solid #9a9a9a',
    padding: '5px',
    margin: '5px 5px 5px 15px',
  },
  openOrCloseText: {
    color: '#9a9a9a',
    fontFamily: 'Lato',
    fontSize: '12px',
  },
  greetingText: {
    color: '#9a9a9a',
    fontFamily: 'Lato',
    fontSize: '12px',
    marginTop: '12px',
    fontStyle: 'italic',
  },
  lockIcon: {
    fontSize: '1.3rem',
    color: '#000000',
    marginRight: '10%',
  },
  adminFormControl: {
    width: '80%',
    height: '45px',
    border: '1px solid #979797',
    borderRadius: '8px',
    paddingLeft: '10px',
    marginLeft: '7.5%',
    backgroundColor: '#FFFFFF',
    fontFamily: 'Lato',
    fontSize: '14px',
    color: '#000000',
  },
});

export const viewResourceStyles = theme => ({
  tableRootContainer: {
    width: '95%',
    margin: '1%',
    overflow: 'auto',
  },
  title: {
    fontFamily: 'circe-rounded',
    fontSize: '18px',
    fontWeight: 'bold',
    padding: '10px 0',
  },
  justifyFlexStartGridItem: {
    justifyContent: 'flex-start',
    alignSelf: 'stretch',
  },
  transactionGridItem: {
    justifyContent: 'flex-start',
    backgroundColor: '#F8F8F8',
    alignSelf: 'stretch',
  },
  rightAlignTransactionGridItem: {
    textAlign: 'right',
    backgroundColor: '#F8F8F8',
    alignSelf: 'stretch',
    overflowWrap: 'break-word',
  },
  subtotalPaddedGridItem: {
    justifyContent: 'flex-start',
    padding: '12px 12px 34px 12px',
    backgroundColor: '#F8F8F8',
    alignSelf: 'stretch',
  },
  subtotalPaddedRightAlignGridItem: {
    textAlign: 'right',
    padding: '12px 12px 34px 12px',
    backgroundColor: '#F8F8F8',
    alignSelf: 'stretch',
  },
  paddedTransactionGridItem: {
    justifyContent: 'flex-start',
    padding: '34px 12px',
    backgroundColor: '#F8F8F8',
    alignSelf: 'stretch',
  },
  paddedRightAlignTransactionGridItem: {
    textAlign: 'right',
    padding: '34px 12px',
    backgroundColor: '#F8F8F8',
    alignSelf: 'stretch',
  },
});

const tableHeadCellBase = {
  fontSize: '13px',
  color: '#868686',
  fontFamily: 'Lato',
  position: navigator.vendor.startsWith('Apple') ? '-webkit-sticky' : 'sticky',
  top: '0',
  background: '#fff',
  zIndex: '1',
};

const bandedTableHeadCellBase = {
  ...tableHeadCellBase,
  textAlign: 'center',
  borderBottom: '2px solid #f2f2f2',
};

const tableRowBase = {
  height: '40px',
};

const dateRangeInputsContainerBase = {
  display: 'flex',
  justifyContent: 'center',
};

const dropdownOuterContainerBase = {
  fontSize: '14px',
  width: '150px',
  margin: '0',
  paddingLeft: '10px',
  fontFamily: 'Lato',
};

const dropdownOuterContainer = {
  ...dropdownOuterContainerBase,
  border: '1.5px solid #000000',
  borderRadius: '5px',
  height: '40px',
  background: '#FFFFFF',
  fontStyle: 'italic',
};

export const v2DropdownStyles = theme => ({
  dropdownOuterContainer: {
    ...dropdownOuterContainer,
  },
  dropdownItemsOuterContainer: {
    ...dropdownOuterContainer,
    width: '120px',
    marginRight: '20px',
  },
  homePageTimescaleDropdownOuterContainer: {
    ...dropdownOuterContainerBase,
    border: '2px solid #ccc',
    borderRadius: '4px',
    height: '35px',
    background: '#FFFFFF',
  },
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: '3px',
  },
  chevron: {
    fontSize: '20px',
    color: '#000000',
    marginRight: '8px',
    cursor: 'pointer',
  },
  chevronItems: {
    fontSize: '20px',
    color: '#ffffff',
    marginRight: '8px',
    cursor: 'pointer',
  },
  selectMenu: {
    width: '100px',
  },
});

export const v2DropdownStyleInstance = v2DropdownStyles();

const baseToolbarContainer = {
  minHeight: '10%',
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginLeft: '1%',
  marginTop: '1%',
  flexWrap: 'wrap',
  alignContent: 'space-evenly',
};

const tableHeadCellWithBgColorBase = {
  ...tableHeadCellBase,
  padding: '20px',
  borderBottom: '1px solid #8c8c8c',
  backgroundColor: '#f3f3f3',
};

export const displayResourceStyles = theme => ({
  editOption: {
    minWidth: '60px',
  },
  tableRootContainer: {
    width: '99%',
    marginLeft: '1%',
    overflow: 'auto',
  },
  tableRootContainerTablet: {
    width: '99%',
    marginLeft: '1%',
    overflowX: 'hidden',
  },
  tableRootContainerOptions: {
    width: '94%',
    margin: '0 3%',
    overflow: 'auto',
  },
  optionsOnModifierTableRoot: {

  },
  tabletTableRowHeight: {
    height: '55px',
  },
  bandedTableRootContainer: {
    width: '100%',
    overflow: 'auto',
  },
  bandedTableFirstHeadCellCenteredText: {
    ...bandedTableHeadCellBase,
    padding: '16.5px 50px 16.5px 16px',
  },
  bandedTableHeadCellCenteredText: {
    ...bandedTableHeadCellBase,
    padding: '16.5px 50px 16.5px 10px',
  },
  bandedTableDarkTableRow: {
    ...tableRowBase,
    backgroundColor: '#fafafa',
  },
  bandedTableLightTableRow: tableRowBase,
  lightTableRowWithMapComponentHeight: {
    height: '400px',
  },
  v1TableRow: {
    ...tableRowBase,
    backgroundColor: '#ffffff',
    boxShadow: '3px 5px 6px -4px rgb(0 0 0 / 10%)',
  },
  tableHeadCell: {
    padding: '20px 10px 20px 10px',
    borderBottom: 'none',
    ...tableHeadCellBase,
  },
  tableHeadCellTablet: {
    padding: '11px 10px 11px 10px',
    borderBottom: 'none',
    ...tableHeadCellBase,
  },
  tableHeadCellCouponSingleRow: {
    ...tableHeadCellBase,
    padding: '20px 11px',
    borderBottom: 'none',
    textAlign: 'center',
    whiteSpace: 'nowrap',
  },
  tableHeadCellLongTitle: {
    padding: '11px 10px',
    borderBottom: 'none',
    whiteSpace: 'normal',
    textAlign: 'left',
    ...tableHeadCellBase,
  },
  tableHeadCenterTitle: {
    ...tableHeadCellBase,
    fontSize: '12px',
    textAlign: 'center',
    borderBottom: 'none',
    padding: '20px 5px',
  },
  tableHeadWithBackgroundColor: {
    ...tableHeadCellWithBgColorBase,
    whiteSpace: 'nowrap',
  },
  tableHeadCellSubresourceList: {
    ...tableHeadCellWithBgColorBase,
    whiteSpace: 'nowrap',
    padding: '20px 10px',
  },
  tableHeadWithSetWidth: {
    ...tableHeadCellWithBgColorBase,
    width: '30%',
  },
  subresourceListTableHeadCellSetWidth: {
    ...tableHeadCellWithBgColorBase,
    width: '30%',
    padding: '20px 10px',
  },
  bulkActionCheckboxTableHeadCell: {
    ...tableHeadCellBase,
    borderBottom: 'none',
    padding: '0',
  },
  bulkActionCheckboxOptionTableHeadCell: {
    ...tableHeadCellBase,
    borderBottom: '1px solid #8c8c8c',
    backgroundColor: '#f3f3f3',
    width: '50px',
    padding: '0',
  },
  lastColumnOrderCell: {
    padding: '20px 3px',
    borderBottom: 'none',
    ...tableHeadCellBase,
  },
  mainTableCell: {
    fontFamily: 'Lato',
    fontSize: '13px',
    color: '#000',
    borderBottom: '2px solid #f2f2f2',
  },
  mainTableCellWithLinkContent: {
    fontFamily: 'Lato',
    fontSize: '13px',
    color: '#000',
  },
  buttonTableCell: {
    padding: '0',
    position: 'relative',
    borderBottom: '2px solid #f2f2f2',
    width: '10px',
  },
  optionsBulkActionTableCell: {
    padding: '0',
    position: 'relative',
    borderBottom: '2px solid #f2f2f2',
    width: '10px',
    borderBottomLeftRadius: '5px',
    borderTopLeftRadius: '5px',
  },
  iconButton: {
    float: 'right',
    backgroundColor: 'transparent',
    height: '20px',
    padding: '0',
    marginRight: '10px',
  },
  threeDotsIconButton: {
    verticalAlign: 'middle',
    backgroundColor: 'transparent',
    height: '20px',
    padding: '0',
    marginRight: '10px',
  },
  toolbarContainer: baseToolbarContainer,
  itemsToolbarContainer: {
    ...baseToolbarContainer,
    marginLeft: '0',
  },
  ordersToolbarContainer: {
    ...baseToolbarContainer,
    alignItems: 'flex-start',
  },
  optionsToolbarContainer: {
    ...baseToolbarContainer,
    backgroundColor: '#fbfbfb',
    marginLeft: '0',
    padding: '1% 0 2% 0',
  },
  toolbarLeftSideOptionContainer: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    margin: '5px 0 5px 35px',
  },
  toolbarLeftSideFlexStartContainer: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    margin: '5px 20px 5px 10px',
  },
  toolbarRightSideFlexEndContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    margin: '5px 20px 5px 0',
  },
  searchTextField: {
    border: '1px solid',
    borderRadius: '3px',
  },
  addNewResButton: {
    backgroundColor: customizedThemes.palette.primary.main,
    color: customizedThemes.palette.primary.white,
    padding: '0',
    fontSize: '11px',
    height: '40px',
    width: '140px',
    fontFamily: 'Lato',
    borderRadius: '5px',
    boxShadow: 'none',
    marginRight: '10px',
  },
  dateRangeInputsContainer: dateRangeInputsContainerBase,
  invalidReportDateRangeMessage: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '5px',
  },
  downloadCsvButtonFlexEndContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end',
  },
  downloadCsvButton: {
    backgroundColor: 'transparent',
    color: customizedThemes.palette.primary.main,
    padding: '0',
    fontSize: '12px',
    fontWeight: '700',
    height: '44px',
    width: '150px',
    fontFamily: 'Lato',
    borderRadius: '0px',
    border: '2px solid #e0592a',
    boxShadow: 'none',
    marginRight: '20px',
  },
  downloadCsvButtonIcon: {
    fontSize: '20px',
    marginLeft: '5px',
  },
  exportButton: {
    backgroundColor: '#777777',
    color: '#fff',
    padding: '0',
    fontSize: '11px',
    height: '40px',
    width: '140px',
    fontFamily: 'Lato',
    borderRadius: '5px',
    boxShadow: 'none',
  },
  importButton: {
    backgroundColor: '#777777',
    color: '#fff',
    padding: '0',
    verticalAlign: 'middle',
    textAlign: 'center',
    display: 'inline-block',
    fontSize: '11px',
    height: '40px',
    width: '140px',
    fontFamily: 'Lato',
    borderRadius: '5px',
    boxShadow: 'none',
    fontWeight: 500,
    letterSpacing: '0.02857em',
    textTransform: 'uppercase',
    cursor: 'pointer',
  },
  importButtonSpan: {
    marginTop: 13,
    display: 'block',
  },
  viewMoreRow: {
    height: '35px',
  },
  viewMoreTableCell: {
    textAlign: 'center',
    padding: 0,
    height: '35px',
    borderBottom: 'none',
    fontFamily: 'Lato',
    fontWeight: 'bold',
  },
  viewMoreChoiceRow: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  viewMoreChoiceText: {
    fontSize: '0.7rem',
    margin: '0 10px',
  },
  keyDownIcon: {
    width: '15px',
  },
  viewMoreButton: {
    fontSize: '11px',
    fontFamily: 'Lato',
    fontWeight: 'bold',
  },
  checkBox: {
    padding: '0 0 0 2px',
    color: customizedThemes.palette.primary.main,
  },
  table: {
    width: '100%',
    borderCollapse: 'separate',
    borderSpacing: '0 10px',
  },
  tableHead: {
    width: '100%',
    borderBottom: 'solid 1px #cecece',
  },
  shortenTableHead: {
    width: '94%',
  },
  tableBody: {
    height: '90%',
    width: '100%',
  },
  emptyTableCell: {
    borderBottom: 'none',
    padding: '15px',
  },
  sendPushNotificationButton: {
    width: '150px',
    position: 'absolute',
    right: '2.5%',
    margin: '0',
    top: '3%',
  },
  checkboxAndThreeDotsMenuContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    alignItems: 'center',
  },
  checkboxContainerFlexStart: {
    display: 'flex',
    justifyContent: 'flex-start',
    width: '100%',
    alignItems: 'center',
  },
  bulkActionCheckbox: {
    fontSize: '22px',
    color: '#868686',
    position: 'relative',
    left: '10px',
  },
  uncheckedCheckboxIcon: {
    fontSize: '22px',
    color: '#868686',
  },
  checkedCheckboxIcon: {
    fontSize: '22px',
    color: customizedThemes.palette.primary.main,
  },
  checkCircleSpacing: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  excessCountCircle: {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 50,
    background: '#000000',
    width: '22px',
    height: '22px',
  },
  excessCountText: {
    color: '#ffffff',
    fontSize: '11px',
    marginTop: '-1px',
  },
  bulkActionDropdown: v2DropdownStyleInstance.dropdownOuterContainer,
  bulkActionInnerSelect: v2DropdownStyleInstance.root,
  bulkActionDropdownChevron: v2DropdownStyleInstance.chevron,
  bulkActionSelectMenu: v2DropdownStyleInstance.selectMenu,
  bulkActionDropdownItems: {
    fontSize: '11px',
    width: '130px',
    margin: '0',
    paddingLeft: '10px',
    fontFamily: 'Lato',
    border: '1.5px solid #000000',
    borderRadius: '5px',
    height: '37px',
    background: '#000000',
    color: '#ffffff',
  },
  bulkActionInnerSelectItems: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: '3px',
  },
  bulkActionDropdownChevronItems: {
    fontSize: '12px',
    color: '#ffffff',
    marginRight: '8px',
    cursor: 'pointer',
  },
  bulkActionSelectMenuItems: {
    width: '100px',
  },
  taxSelect: {
    display: 'flex',
    justifyContent: 'flex-end',
    fontSize: '16px',
    alignItems: 'center',
    fontFamily: 'Lato-Regular',
    paddingRight: '25px',
  },
});

const removeTagButtonBase = {
  alignItems: 'center',
  borderTopLeftRadius: '0',
  borderBottomLeftRadius: '0',
  display: 'flex',
  backgroundColor: '#e0592a',
  boxSizing: 'border-box',
};
export const searchableSelectStyle = theme => ({
  control: {
    marginTop: '0px',
    marginBottom: '0px',
    border: '1px solid rgb(151, 151, 151)',
    minHeight: '47px',
    borderRadius: '8px',
    boxShadow: 'none',
  },
  container: {
    width: '100%',
  },
  noOptionsMessage: {
    fontFamily: 'Lato',
    fontWeight: '400',
    fontSize: '1rem',
    height: '45px',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginLeft: '16px',
  },
  placeholder: {
    fontFamily: 'Lato',
    fontSize: '16px',
    padding: '6px 32px 7px 0',
    color: 'rgba(0, 0, 0, 0.87)',
  },
  menu: {
    margin: '0px',
    boxShadow: '0 10px 16px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19)',
    position: 'absolute',
    zIndex: 99,
  },
  disabledOption: {
    color: 'rgba(0,0,0,0.14)',
    fontFamily: 'Lato',
    fontSize: '16px',
    padding: '11px 16px',
    fontWeight: '400',
    minHeight: '45px',
  },
  focusedOption: {
    backgroundColor: 'rgba(0,0,0,0.07)',
    color: 'rgba(0,0,0,0.87)',
    fontFamily: 'Lato',
    fontSize: '16px',
    padding: '11px 16px',
    fontWeight: '400',
    minHeight: '45px',
  },
  unFocusedOption: {
    color: 'rgba(0,0,0,0.87)',
    fontFamily: 'Lato',
    fontSize: '16px',
    padding: '11px 16px',
    fontWeight: '400',
    minHeight: '45px',
  },
  selectedOption: {
    backgroundColor: 'rgba(0,0,0,0.14)',
    color: 'rgba(0,0,0,0.87)',
    fontFamily: 'Lato',
    fontSize: '16px',
    padding: '11px 16px',
    fontWeight: '400',
    minHeight: '45px',
  },
  multiValueLabel: {
    fontFamily: 'Lato',
    fontSize: '14px',
    fontWeight: '400',
    backgroundColor: customizedThemes.palette.primary.main,
    color: customizedThemes.palette.primary.white,
    borderTopRightRadius: '0',
    borderBottomRightRadius: '0',
  },
  multiValueRemove: {
    backgroundColor: '#e0592a',
    fontSize: '20px',
    color: '#ffffff',
    position: 'relative',
    top: '0.5px',
  },
  removeTagButtonParent: removeTagButtonBase,
  tagRightSegmentWithoutRemove: {
    ...removeTagButtonBase,
    padding: '3px',
  },
  singleValue: {
    fontFamily: 'Lato',
    fontSize: '14px',
    fontWeight: '400',
  },
  valueContainer: {
    padding: '9px',
  },
  input: {
    fontFamily: 'Lato',
    fontSize: '16px',
    color: 'rgba(0,0,0,0.87)',
  },
});

const baseTimeLimitContainer = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  width: '98%',
};

const boldLatoFont = {
  fontFamily: 'Lato',
  fontWeight: 'bold',
};

const itemCustomizationsField = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  width: '20%',
  height: '100%',
  alignItems: 'center',
};

const infoIcon = {
  color: '#b3b3b3',
  transform: 'scale(0.8)',
};

const borderStyle = {
  border: '1px solid #979797',
  borderRadius: '8px',
  background: customizedThemes.palette.primary.white,
};
const iosSwitchStylesBase = {
  switchBase: {
    '&$checked': {
      color: '#fff',
      '& + $bar': {
        backgroundColor: '#52d869',
        opacity: 1,
      },
    },
  },
  checked: {
    opacity: 1,
  },
  icon: {
    width: '16px',
    height: '16px',
    marginTop: '6px',
  },
  bar: {
    backgroundColor: '#c5d0de',
    height: '20px',
    width: '34px',
    borderRadius: 13,
    opacity: '1',
  },
};
export const resourceFormStyle = theme => ({
  columnFieldPadding: {
    padding: '12px 12px 0',
    minHeight: '90px',
  },
  button: {
    width: '200px',
    height: '40px',
    borderRadius: '0',
    backgroundColor: '#9b9b9b',
    color: '#ffffff',
    fontFamily: 'Lato',
    fontSize: '12px',
    fontWeight: 'bold',
    margin: '10px 12px',
  },
  createEditTierMainContainer: {
    flexDirection: 'row',
    width: '100%',
  },
  deleteAddAnotherContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginLeft: '10px',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '99%',
    alignItems: 'center',
  },
  containerTax: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '99%',
    alignItems: 'flex-start',
  },
  taxStepText: {
    fontFamily: 'Lato-Bold',
    fontSize: '12px',
    color: customizedThemes.palette.primary.main,
  },
  taxTitle: {
    fontFamily: 'Lato-Bold',
    fontSize: '20px',
    color: customizedThemes.palette.primary.black,
  },
  taxSubtitle: {
    fontFamily: 'Lato-Regular',
    fontSize: '16px',
    color: customizedThemes.palette.primary.grey,
  },
  taxSwitchLabel: {
    fontFamily: 'Lato-Regular',
    fontSize: '14px',
    margin: '5px 7px 0',
  },
  taxIndeterminateColor: {
    fontSize: '22px',
    color: customizedThemes.palette.primary.main,
  },
  taxLocationsListRoot: {
    padding: 0,
  },
  taxLocationsListRootChecked: {
    padding: 0,
    backgroundColor: '#ffddb6',
  },
  taxLocationsListItemRoot: {
    height: '50px',
  },
  taxLocationsListItemProductsRoot: {
    paddingLeft: '0',
    height: '50px',
    paddingRight: '24px',
  },
  taxDropdownArrowIcon: {
    marginRight: 0,
  },
  taxLocationsCheckbox: {
    width: '5%',
    justifyContent: 'flex-end',
  },
  taxLocationListItemSecondaryAction: {
    padding: 0,
  },
  taxCategoriesListRoot: {
    padding: '0 0 0 5%',
    marginRight: '5%',
    width: '95%',
    justifyContent: 'flex-end',
  },
  taxCategoriesListRootChecked: {
    padding: '0 0 0 5%',
    marginRight: '5%',
    width: '95%',
    justifyContent: 'flex-end',
    backgroundColor: '#ffddb6',
  },
  taxProductsListRoot: {
    padding: '0 0 0 5%',
    marginRight: '5%',
    width: '95%',
    justifyContent: 'flex-end',
  },
  taxProductsListRootChecked: {
    padding: '0 0 0 5%',
    marginRight: '5%',
    width: '95%',
    justifyContent: 'flex-end',
    backgroundColor: '#ffddb6',
  },
  taxProductsTextRoot: {
    marginLeft: '56px',
  },
  title: {
    fontFamily: 'circe-rounded',
    fontSize: '24px',
    fontWeight: 'bold',
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    height: '100%',
    overflowX: 'hidden',
    overflowY: 'auto',
  },
  gridContainerBordered: {
    border: '1px solid #9a9a9a',
    borderRadius: '5px',
    padding: '2% 20px 10px 20px',
    margin: '20px',
    width: '100%',
  },
  gridContainer: {
    padding: '2% 20px 10px 20px',
    margin: '0',
  },
  editTaxFieldsContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  editTaxWarningContainer: {
    display: 'flex',
    height: '40px',
    borderRadius: '5px',
    backgroundColor: customizedThemes.palette.primary.main,
    alignItems: 'center',
    padding: '0 15px',
    marginBottom: '10px',
  },
  warningIcon: {
    color: customizedThemes.palette.primary.white,
  },
  warningText: {
    color: customizedThemes.palette.primary.white,
    paddingLeft: '5px',
    fontSize: '16px',
  },
  reEnableButtonRoot: {
    color: customizedThemes.palette.primary.white,
    fontSize: '16px',
    textDecoration: 'underline',
    textTransform: 'none',
  },
  createEditTierContainerNoImage: {
    padding: '2% 20px 10px 20px',
    margin: '0',
    width: '50%',
  },
  createEditTierDropdownContainer: {
    width: '100%',
    padding: '10px',
  },
  createEditTierDropdownTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    paddingBottom: '10px',
  },
  createEditTierImage: {
    width: '50%',
  },
  gridContainerColumn: {
    padding: '12px 12px',
    margin: '0',
    width: '100%',
  },
  gridContainerTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0px 12px',
    fontSize: '20px',
    width: '50%',
  },
  hintText: {
    fontSize: '14px',
    fontFamily: 'Lato-BoldItalic',
    color: '#e0592a',
  },
  subResourceContainer: {
    width: '99%',
    padding: '0 2%',
    overflow: 'auto',
  },
  subResourceContainerHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '15px 0',
    alignItems: 'center',
  },
  subgridContainer: {
    maxHeight: '650px',
    borderRadius: '1%',
  },
  subgridItemContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    background: '#f4f4f4',
    borderRadius: '5px',
    padding: '1%',
    width: '99%',
    margin: '0px 2px',
    alignItems: 'flex-start',
  },
  tableRowContainer: {
    background: '#f4f4f4',
    borderBottom: 'none',
  },
  tableHead: {
    height: '30px',
    borderBottom: 'none',
  },
  tableCell: {
    color: customizedThemes.palette.primary.black,
    fontFamily: 'Lato',
    fontWeight: 'bold',
    fontSize: '13px',
    borderBottom: 'none',
  },
  gridItem: {
    paddingBottom: '0',
    minHeight: '90px',
  },
  gridItemColumn: {
    paddingBottom: '0',
    minHeight: '40px',
  },
  subgridItem: {
    margin: '0 5px',
  },
  subgridItemMobile: {
    margin: '0 3px',
    maxWidth: '15.5%',
  },
  itemTitle: {
    ...boldLatoFont,
  },
  itemTitleColumn: {
    ...boldLatoFont,
    width: '50%',
  },
  itemTitleMobile: {
    ...boldLatoFont,
    fontSize: '11px',
    paddingLeft: '2%',
    whiteSpace: 'nowrap',
  },
  itemTitleMobilePoints: {
    ...boldLatoFont,
    width: '43.5px',
    fontSize: '11px',
    paddingLeft: '2%',
    whiteSpace: 'nowrap',
  },
  itemTitleSingleLine: {
    ...boldLatoFont,
    whiteSpace: 'nowrap',
  },
  itemTitleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  itemTitleContainerOneLine: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '50%',
    alignItems: 'center',
  },
  itemTitleContainerColumn: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  customizationTitle: {
    padding: '20px 0 20px 0',
    fontFamily: 'circe-rounded',
    fontWeight: '700',
    fontSize: '14px',
  },
  isolatedField: {
    width: '50%',
    paddingTop: '2%',
  },
  buttonWrapper: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    height: '5%',
  },
  applyChangeButton: {
    border: '2px solid #e0592a',
    color: customizedThemes.palette.primary.main,
    fontSize: '11px',
    minWidth: '140px',
    minHeight: '35px',
    fontFamily: 'Lato',
    borderRadius: '0px',
    boxShadow: 'none',
    padding: '0',
    marginLeft: '20px',
    position: 'absolute',
    right: '2%',
  },
  addTimeLimitLink: {
    textDecoration: 'underline',
    cursor: 'pointer',
    margin: '3% 0 0 10px',
    color: '#e0592a',
    width: '80px',
  },
  bottomBelowPaperContainer: {
    width: '94%',
    display: 'flex',
    paddingBottom: '3%',
  },
  bottomLeftBelowPaperSubContainer: {
    flex: 1,
    display: 'flex',
    position: 'relative',
    top: '-15px',
  },
  bottomLeftBelowPaperSubContainerTax: {
    flex: 1,
    display: 'flex',
    position: 'relative',
    top: '-15px',
    marginLeft: '3%',
  },
  appVersionAndBuildNumber: {
    color: customizedThemes.palette.primary.black,
    fontFamily: 'Lato',
    fontSize: '12px',
    fontStyle: 'italic',
    minHeight: '15px',
  },
  applyChangesButtonSolidContainer: {
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
  },
  applyChangesButtonSolid: {
    width: '200px',
    height: '50px',
    borderRadius: '0',
    backgroundColor: customizedThemes.palette.primary.main,
    color: customizedThemes.palette.primary.white,
    fontFamily: 'Lato',
    fontSize: '12px',
    fontWeight: 'bold',
  },
  taxesActionsMargin: {
    width: '15px',
  },
  saveTaxesButton: {
    width: '140px',
    height: '40px',
    borderRadius: '6px',
    backgroundColor: customizedThemes.palette.primary.main,
    color: customizedThemes.palette.primary.white,
    fontFamily: 'Lato',
    fontSize: '16px',
    boxShadow: 'none',
    textTransform: 'none',
  },
  backTaxesButton: {
    width: '140px',
    height: '40px',
    borderRadius: '6px',
    backgroundColor: customizedThemes.palette.primary.grey,
    color: customizedThemes.palette.primary.white,
    fontFamily: 'Lato',
    fontSize: '16px',
    boxShadow: 'none',
    textTransform: 'none',
  },
  applyChangesButtonSpinner: {
    color: customizedThemes.palette.primary.white,
  },
  textFieldStyle: {
    ...borderStyle,
    width: '100%',
  },
  textFieldStyleColumn: {
    ...borderStyle,
    width: '30%',
    height: '40px',
  },
  customizationTextFieldStyle: {
    ...borderStyle,
    minWidth: '47px',
    maxWidth: '47px',
    height: '30px',
  },
  errorTextFieldStyle: {
    border: '1px solid red',
    borderRadius: '8px',
    width: '100%',
    backgroundColor: customizedThemes.palette.primary.white,
  },
  errorTextFieldStyleColumn: {
    border: '1px solid red',
    borderRadius: '8px',
    width: '30%',
    backgroundColor: customizedThemes.palette.primary.white,
  },
  errorMessageStyle: {
    color: 'red',
  },
  maxCharMessageStyle: {
    color: 'black',
    fontSize: '11px',
  },
  hoursErrorMessage: {
    color: 'red',
    padding: '10px',
    width: '480px',
    whiteSpace: 'pre-wrap',
  },
  fieldTypeStyle: {
    ...borderStyle,
    height: '45px',
    paddingLeft: '10px',
    fontFamily: 'Lato',
  },
  customizationDropdownStyle: {
    ...borderStyle,
    height: '45px',
    paddingLeft: '10px',
    fontFamily: 'Lato',
    margin: 'auto',
    marginTop: '30px',
    width: '300px',
  },
  formDropdownFieldStyle: {
    ...borderStyle,
    height: '45px',
    paddingLeft: '10px',
    fontFamily: 'Lato',
  },
  couponRestrictionUneditableTrueValueText: {
    height: '45px',
    fontFamily: 'Lato',
    background: customizedThemes.palette.primary.white,
    margin: '15px 0 0 2px',
    width: '300px',
    flexDirection: 'column',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    flex: 1,
  },
  normalInputPropStyle: {
    style: {
      height: '45px',
      padding: '0 0 0 10px',
      fontFamily: 'Lato',
    },
  },
  normalInputPropStyleTiming: {
    style: {
      height: '40px',
      padding: '0 0 0 10px',
      fontFamily: 'Lato',
    },
  },
  descriptionInputPropStyle: {
    style: {
      padding: '10px',
      fontFamily: 'Lato',
    },
  },
  timeLimitSmallContainer: baseTimeLimitContainer,
  timeLimitContainerWithHeightForErrors: {
    ...baseTimeLimitContainer,
    margin: '15px 0',
  },
  baseTimeLimitContainerMobile: {
    flexDirection: 'column',
  },
  timePickersAndButtonsContainer: {
    display: 'flex',
  },
  collapsedTimePickerAndErrorContainer: {
    flexDirection: 'column',
  },
  iconSmallContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '98%',
  },
  iconSmallContainerColumnView: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    width: '98%',
  },
  legendCheckboxContainer: {
    marginTop: '10px',
  },
  checkBoxAndLabel: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '200px',
  },
  iconCheckBox: {
    padding: '0',
    color: customizedThemes.palette.primary.main,
    marginRight: '8px',
  },
  switchAndText: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  yesOrNoText: {
    fontFamily: 'Lato',
    fontSize: '14px',
    paddingTop: '18px',
    width: '20px',
  },
  daysButton: {
    width: '30px',
    minWidth: '30px',
    height: '30px',
    fontFamily: 'Lato',
    fontSize: '10px',
    marginRight: '4px',
    boxShadow: 'none',
    borderRadius: '0',
    backgroundColor: '#e7e7e7',
    color: customizedThemes.palette.primary.black,
  },
  daysButtonSelected: {
    backgroundColor: customizedThemes.palette.primary.main,
    color: customizedThemes.palette.primary.white,
  },
  imgAndTimePicker: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  alarmImg: {
    width: '25px',
    height: '25px',
    padding: '5px',
  },
  timePickerStyle: {
    width: '60px',
  },
  timePickerInputProp: {
    style: {
      fontFamily: 'Lato',
      fontSize: '14px',
    },
  },
  dashBetweenTimePicker: {
    padding: '5px 10px 5px 10px',
  },
  daysOfWeekErrorDiv: {
    maxWidth: '200px',
  },
  timeLimitErrorText: {
    fontFamily: 'Lato',
    fontSize: '12px',
    color: 'red',
    margin: 0,
  },
  startEndTimeErrorDiv: {
    maxWidth: '70px',
  },
  viewResourceBtnWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    height: '5%',
  },
  viewResourceButtons: {
    border: '2px solid #e0592a',
    color: customizedThemes.palette.primary.main,
    fontSize: '14px',
    width: '140px',
    minHeight: '35px',
    fontFamily: 'Lato',
    borderRadius: '0px',
    boxShadow: 'none',
    padding: '0',
    marginRight: '20px',
    backgroundColor: '#fff',
  },
  itemCustomizationsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    height: '70px',
    alignItems: 'center',
    marginLeft: '0px',
    width: '100%',
  },
  itemCustomizationTitleMobile: {
    ...boldLatoFont,
    fontSize: '11px',
    minWidth: '10%',
    maxWidth: '10%',
    paddingRight: '2%',
  },
  itemCustomizationTitle: {
    ...boldLatoFont,
    minWidth: '15%',
    maxWidth: '15%',
    paddingRight: '1%',
  },
  itemCustomizationsFreeField: {
    ...itemCustomizationsField,
    marginLeft: '3%',
  },
  itemCustomizationsField: {
    ...itemCustomizationsField,
    marginRight: '1%',
  },
  itemCustomizationsFieldText: {
    fontFamily: 'Lato',
    marginRight: '10px',
  },
  itemCustomizationsFieldTextMobile: {
    fontFamily: 'Lato',
    fontSize: '11px',
    marginRight: '3%',
  },
  iconButton: {
    padding: '0px',
  },
  iosSwitchStyles: iosSwitchStylesBase,
  iosSwitchStylesForSectionedFields: {
    ...iosSwitchStylesBase,
    bottom: '2px',
  },
  iosSwitchRoot: {
    width: '34px',
  },
  iosSwitchBase: {
    width: '20px',
  },
  itemCustomizationContainer: {
    width: '100%',
  },
  itemCustomizationTitleContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  addCusTextLink: {
    fontFamily: 'Lato',
    fontStyle: 'italic',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  addItemCusDialogContainer: {
    width: '500px',
    height: '420px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 0,
    position: 'relative',
  },
  itemCusDialogCloseBtn: {
    position: 'absolute',
    width: '50px',
    right: '2%',
    top: '5px',
    color: '#000',
  },
  itemCusDialogTitle: {
    fontFamily: 'Lato',
    fontWeight: 'bold',
    fontSize: '23px',
    marginTop: '20px',
  },
  itemCusBtnInDialog: {
    backgroundColor: customizedThemes.palette.primary.main,
    color: customizedThemes.palette.primary.white,
    width: '200px',
    marginTop: '30px',
  },
  itemCusDialogCancelText: {
    fontFamily: 'Lato',
    textDecoration: 'underline',
    marginTop: '10px',
  },
  dialogDescription: {
    fontFamily: 'Lato',
    fontSize: '14px',
    padding: '20px',
    textAlign: 'center',
  },
  infoIcon: {
    ...infoIcon,
    fontSize: '21px',
  },
  taxLocationsButton: {
    height: '45px',
    borderRadius: '6px',
    borderColor: customizedThemes.palette.primary.grey,
    margin: '20px 0 15px',
    justifyContent: 'space-between',
    textTransform: 'none',
    color: customizedThemes.palette.primary.grey,
  },
  infoIconMobile: {
    ...infoIcon,
    fontSize: '16px',
  },
  infoContainerNoMargin: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  advancedOptionsTextLinkContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  advancedOptionsTextLink: {
    fontFamily: 'Lato',
    fontStyle: 'italic',
    textDecoration: 'underline',
    minWidth: '108px',
    textAlign: 'right',
    cursor: 'pointer',
    marginRight: '32px',
  },
  helpfulInstructions: {
    padding: '5px',
  },
  userInstructions: {
    padding: '12px 5px 5px 5px',
  },
  userInstructionsError: {
    padding: '12px 5px 5px 5px',
    color: 'red',
  },
  dialogImage: {
    marginTop: '50px',
  },
  searchableSelectContainer: {
    marginTop: '16px',
  },
  notificationReportRowContainer: {
    width: '100%',
    alignItems: 'center',
    padding: '12px 0 0 12px',
    justifyContent: 'space-between',
  },
  reportDropdownEmailContainer: {
    width: '35%',
  },
  reportDropdown: {
    ...borderStyle,
    paddingLeft: '10px',
    fontFamily: 'Lato',
    height: '40px',
    marginBottom: '8px',
  },
  reportEmailLabel: {
    width: '10%',
    fontFamily: 'Lato',
    fontWeight: 'bold',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  reportEmailInput: {
    ...borderStyle,
    height: '40px',
    width: '100%',
  },
  deleteIconContainer: {
    width: '30px',
  },
  deleteIcon: {
    fontSize: '24px',
    margin: '17% 0 0 30%',
  },
  addMoreText: {
    textDecoration: 'underline',
    cursor: 'pointer',
    margin: '10px 0',
    color: '#e0592a',
    fontStyle: 'italic',
  },
  addRecipientButton: {
    width: '200px',
    height: '40px',
    borderRadius: '0',
    backgroundColor: '#e0592a',
    color: '#ffffff',
    fontFamily: 'Lato',
    fontSize: '12px',
    fontWeight: 'bold',
    margin: '10px 0',
  },
  notificationReportsTitleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '50%',
    alignItems: 'center',
    height: '40px',
    paddingLeft: '12px',
  },
  recipientTitle: {
    fontSize: '14px',
    fontFamily: 'Lato',
    width: '90%',
    fontWeight: 'bold',
  },
  recipientsContainer: {
    padding: '0 12px',
    display: 'flex',
    width: '50%',
  },
  notificationReportsBorder: {
    borderTop: '1px solid #979797',
    justify: 'center',
    height: '15px',
    margin: '30px 12px 10px',
  },
  reportEmailInputProps: {
    height: '40px',
    padding: '0 10px 0 10px',
    fontFamily: 'Lato',
  },
});

export const lineChartStyles = theme => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'row',
  },
  lineSeries: {
    width: 700,
    height: 300,
  },
  XYPlot: {
    marginBottom: 100,
    paddingTop: 20,
    labelAngle: 300,
  },
  markSeries: {
    fill: 'red',
  },
});

export const legendColorBoxBase = {
  width: '15px',
  height: '15px',
  borderRadius: '3px',
};

const statsListBase = { padding: 0 };
const PIE_CHART_DONUT_RELATIVE_HEIGHT = 60;
const PIE_CHART_LEGEND_REL_HEIGHT = 100 - PIE_CHART_DONUT_RELATIVE_HEIGHT;
const centeredTitleHeight = '50px';
export const pieChartWithLegendBelowStyles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    height: `calc(100% - ${centeredTitleHeight})`,
  },
  pieChartAndInnerTextContainer: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    height: `${PIE_CHART_DONUT_RELATIVE_HEIGHT}%`,
    width: `${PIE_CHART_DONUT_RELATIVE_HEIGHT}%`,
    minHeight: '100px',
    minWidth: '100px',
  },
  innerText: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
  },
  pieChartSkeletonContainer: {
    height: `${PIE_CHART_DONUT_RELATIVE_HEIGHT}%`,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  pieLegendSkeletonContainer: {
    height: `${PIE_CHART_LEGEND_REL_HEIGHT}%`,
    width: '100%',
  },
  totalPointsText: {
    fontSize: '35px',
    textAlign: 'center',
    fontFamily: 'Lato',
    fontWeight: 'bold',
  },
  pointsText: {
    fontSize: '12px',
    fontFamily: 'Lato',
    paddingBottom: '15px',
    textAlign: 'center',
  },
  statsListContainer: {
    height: `${PIE_CHART_LEGEND_REL_HEIGHT}%`,
    overflow: 'auto',
    padding: 0,
    width: '100%',
  },
  statsList: statsListBase,
  popperStatsList: {
    display: 'flex',
    flexWrap: 'wrap',
    maxWidth: '40vw',
    padding: '10px',
  },
  popperStatsItem: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    height: '30px',
    minWidth: '160px',
    padding: '0 10px',
    alignItems: 'center',
  },
  statsListItem: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    height: '30px',
    minWidth: '160px',
    padding: '0',
    margin: '0 0 5px 0',
  },
  percentageText: {
    fontFamily: 'Lato',
    fontSize: '16px',
    padding: '0 5px',
  },
  chosenChartStyle: {
    stroke: 'black',
    strokeWidth: '2px',
  },
});

export const pieChartWithLegendBesideStyles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  pieChartAndInnerTextContainer: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    margin: 'auto',
    height: '50%',
    width: '50%',
    minHeight: '100px',
    minWidth: '100px',
  },
  innerText: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
  },
  totalPointsText: {
    fontSize: '35px',
    textAlign: 'center',
    fontFamily: 'Lato',
    fontWeight: 'bold',
  },
  pointsText: {
    fontSize: '12px',
    fontFamily: 'Lato',
    paddingBottom: '15px',
    textAlign: 'center',
  },
  statsListContainer: {
    height: '100%',
    overflow: 'auto',
    padding: 0,
    width: '50%',
  },
  statsList: statsListBase,
  statsListItem: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    height: '40px',
    minWidth: '160px',
    padding: '0',
  },
  percentageText: {
    fontFamily: 'Lato',
    fontSize: '13px',
    padding: '0 5px',
    lineHeight: 1,
  },
  chosenChartStyle: {
    stroke: 'black',
    strokeWidth: '2px',
  },
});

export const selfServeStyles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignContent: 'stretch',
    alignItems: 'flex-start',
    paddingTop: 20,
    paddingLeft: 50,
    paddingRight: 50,
  },
  controls: {

  },
  preview: {

  },
});

export const menuPageStyle = theme => ({
  title: {
    fontFamily: 'circe-rounded',
    fontSize: '18px',
    fontWeight: 'bold',
    padding: '10px',
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    height: '94%',
    width: '100%',
  },
  leftContainer: {
    width: '80%',
    margin: '3% 0% 3% 3%',
  },
  rightContainer: {
    width: '20%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    margin: '3% 3% 3% 1%',
  },
  smallPaper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  tableWrapper: {
    height: '90%',
    overflow: 'auto',
    margin: '0 1% 0 1%',
  },
  productsContainer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  button: {
    border: '2px solid #e0592a',
    color: customizedThemes.palette.primary.main,
    fontSize: '11px',
    width: '85%',
    minHeight: '35px',
    fontFamily: 'Lato',
    borderRadius: '0px',
    boxShadow: 'none',
    alignSelf: 'center',
    margin: '5px 0px 15px 0px',
    padding: '0',
  },
});

const paperBase = {
  margin: '3% 2% 3% 2%',
  width: '94%',
  height: '95%',
  overflowX: 'hidden',
  overflowY: 'hidden',
};
const container = {
  display: 'flex',
  flexDirection: 'column',
  height: '98%',
  width: 'auto',
  alignItems: 'center',
  overflow: 'hidden',
  backgroundColor: customizedThemes.palette.primary.background,
};

export const productCardStyle = () => ({
  cardStyle: {
    margin: '6px 0',
  },
  disabledCard: {
    margin: '6px 0',
    opacity: 0.5,
  },
  hoveredCardStyle: {
    margin: '6px 0',
    border: '2px solid #e0592a',
  },
  cardContentStyle: {
    padding: '6px',
  },
  cardContentChildStyle: {
    display: 'flex',
    flexDirection: 'row',
  },
  checkBoxStyle: {
    width: '3%',
    justifyContent: 'flex-start',
  },
  cardActionAreaStyle: {
    width: '94%',
  },
  taxCardActionAreaStyle: {
    width: '96%',
  },
  categoryCardActionAreaStyle: {
    width: '26%',
  },
  categoryHiddenText: {
    fontSize: '12px',
  },
  categorySwitch: {
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  categorySwitchContainer: {
    width: '67%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  actionAreaStyle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  imageContainerStyle: {
    width: '12%',
    justifyContent: 'flex-start',
    position: 'relative',
  },
  disabledTextStyle: {
    color: '#000000',
    fontWeight: '600',
    fontSize: '13.5px',
    position: 'absolute',
    top: '50%',
    left: '37px',
    transform: 'translate(-50%, -50%)',
  },
  imageStyle: {
    width: '75px',
    height: '60px',
    borderRadius: '8px',
  },
  disabledImageStyle: {
    width: '75px',
    height: '60px',
    borderRadius: '8px',
    opacity: '50%',
  },
  locationsTextStyle: {
    width: '27%',
    justifyContent: 'flex-start',
    whiteSpace: 'pre-line',
    color: '#000000',
  },
  percentageTextStyle: {
    width: '25%',
    justifyContent: 'flex-start',
    whiteSpace: 'pre-line',
    color: '#000000',
  },
  locationsTextDisabledStyle: {
    width: '27%',
    justifyContent: 'flex-start',
    whiteSpace: 'pre-line',
    color: '#a5a5a5',
  },
  nameTextStyle: {
    width: '27%',
    justifyContent: 'flex-start',
    color: '#000000',
  },
  taxNameTextStyle: {
    width: '30%',
    justifyContent: 'flex-start',
    color: '#000000',
    paddingLeft: '2%',
  },
  nameTextDisabledStyle: {
    width: '27%',
    justifyContent: 'flex-start',
    color: '#a5a5a5',
  },
  categoryNameTextStyle: {
    width: '100%',
    justifyContent: 'flex-start',
    color: '#000000',
  },
  categoryNameTextDisabledStyle: {
    width: '100%',
    justifyContent: 'flex-start',
    color: '#a5a5a5',
  },
  priceTextStyle: {
    width: '7%',
    justifyContent: 'flex-start',
    color: '#000000',
  },
  priceTextDisabledStyle: {
    width: '7%',
    justifyContent: 'flex-start',
    color: '#a5a5a5',
  },
  threeDotStyle: {
    width: '3%',
    justifyContent: 'center',
  },
});

export const commonResourceStyle = theme => ({
  container: {
    ...container,
    ...(theme && {
      [theme.breakpoints.down('md')]: {
        margin: 'auto 20px',
      },
    }),
  },
  innerContainer: {
    ...container,
    ...(theme && {
      [theme.breakpoints.down('md')]: {
        margin: 'auto 20px',
      },
    }),
    width: '94%',
  },
  taxInnerContainer: {
    ...container,
    ...(theme && {
      [theme.breakpoints.down('md')]: {
        margin: 'auto 20px',
      },
    }),
    width: '60%',
    marginRight: '34%',
  },
  infoContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '94%',
    margin: '2% 3% 0',
  },
  infoText: {
    marginLeft: '10px',
  },
  itemsContainer: {
    overflow: 'auto',
    height: '100%',
    width: '100%',
    marginBottom: '45px',
  },
  categoriesContainer: {
    overflow: 'auto',
    height: '100%',
    width: '100%',
    marginBottom: '45px',
    backgroundColor: '#f3f3f3',
  },
  selectAllCheckboxContainer: {
    width: '94%',
    justifyContent: 'flex-start',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: '1%',
    borderBottom: '1px solid #8c8c8c',
  },
  taxesHeaderContainer: {
    width: '98%',
    justifyContent: 'flex-start',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: '2%',
    marginRight: '2%',
    borderBottom: '1px solid #8c8c8c',
  },
  selectAllCheckBox: {
    width: '3%',
    justifyContent: 'flex-start',
    marginLeft: '6px',
  },
  selectAllText: {
    justifyContent: 'flex-start',
    width: '12%',
  },
  categoryContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: '0 2%',
    width: '96%',
  },
  itemsListContainer: {
    margin: '0 10px',
  },
  categoryHeaderBorderStyle: {
    borderTop: '1px solid #8c8c8c',
    justify: 'center',
    height: '15px',
    margin: '0 20px',
  },
  taxDetailsBorder: {
    borderBottom: '3px solid #8c8c8c',
    justify: 'center',
    height: '15px',
    margin: '0 0 8px 3px',
  },
  itemsCategoryTitleContainer: {
    margin: '12px 0 12px',
  },
  itemsCategoryTitle: {
    fontWeight: '600',
    color: '#000000',
  },
  itemsHeaderCheckBox: {
    width: '3%',
    justifyContent: 'flex-start',
  },
  itemsHeaderText: {
    width: '27%',
    fontWeight: '600',
    justifyContent: 'flex-start',
    color: '#868686',
  },
  itemsHeaderPrice: {
    width: '7%',
    fontWeight: '600',
    justifyContent: 'flex-start',
    color: '#868686',
  },
  gridBackground: {
    backgroundColor: '#f3f3f3',
    paddingTop: '12px',
  },
  itemsHeaderThreeDot: {
    width: '3%',
    justifyContent: 'flex-start',
    marginRight: '1%',
  },
  itemsHeaderImage: {
    width: '12%',
  },
  categoryHeaderContainer: {
    display: 'flex',
    flexDirection: 'row',
    padding: '0 16px',
    alignItems: 'center',
    position: 'sticky',
    top: 0,
    zIndex: 1,
    backgroundColor: '#f3f3f3',
  },
  optionsContainer: {
    ...container,
    ...(theme && {
      [theme.breakpoints.down('md')]: {
        margin: 'auto 20px',
      },
    }),
    height: '100%',
    backgroundColor: '#f3f3f3',
  },
  resourceHeader: {
    display: 'flex',
    flexDirection: 'row',
    width: '94%',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '2% 3% 0 3%',
  },
  editTaxesButtonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '37%',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  taxActionsStyles: {
    fontSize: '12px',
    width: '140px',
    margin: '0',
    paddingLeft: '10px',
    fontFamily: 'Lato',
    borderRadius: '5px',
    height: '40px',
    background: customizedThemes.palette.primary.grey,
    color: customizedThemes.palette.primary.white,
  },
  resourceName: {
    width: '70%',
    fontSize: '25px',
    fontFamily: 'circe-rounded',
  },
  resourceNameTaxes: {
    width: '16%',
    fontSize: '25px',
    fontFamily: 'circe-rounded',
  },
  breadcrumbContainer: {
    width: '25%',
    minWidth: '175px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  breadcrumbContainerTax: {
    width: '47%',
    minWidth: '175px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  breadcrumb: {
    marginLeft: 0,
    marginRight: 0,
  },
  breadcrumbItem: {
    textDecoration: 'underline',
    fontSize: 14,
    fontFamily: 'Lato',
    color: 'black',
  },
  breadcrumbItemActive: {
    fontSize: 14,
    fontFamily: 'Lato',
    color: 'black',
  },
  abovePaperFilterToolbar: {
    display: 'flex',
    width: 'calc(94% - 40px)',
    flexFlow: 'row wrap',
    alignItems: 'center',
    alignContent: 'space-evenly',
    justifyContent: 'flex-start',
    background: 'white',
    padding: '10px 20px 10px 20px',
    margin: '40px 3% 0 3%',
  },
  dateTimePickersNoWrapContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexWrap: 'nowrap',
  },
  leftDateTimePicker: {
    width: '215px',
    margin: '10px 0 10px 2px',
  },
  rightDateTimePicker: {
    width: '215px',
    margin: '10px 0 10px 0',
  },
  dateTimePickerDashInBetween: {
    padding: '10px 10px 10px 10px',
  },
  paper: {
    ...paperBase,
    ...(theme && {
      [theme.breakpoints.down('md')]: {
        width: '100%',
      },
    }),
  },
  paperNoHeight: {
    margin: '3% 2%',
    width: '94%',
    overflow: 'hidden',
  },
  paperNoHeightTax: {
    margin: '3% 3%',
    width: '50%',
    overflow: 'hidden',
  },
  optionsPaper: {
    ...paperBase,
    width: '100%',
    boxShadow: 'none',
    margin: '0',
    backgroundColor: '#f3f3f3',
  },
  ordersTablePaper: {
    ...paperBase,
  },
  paperAboveReports: {
    width: '94%',
  },
  paperInnerContainer: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  unauthorizedMessage: {
    fontSize: '25px',
    fontFamily: 'circe-rounded',
    maxWidth: '70%',
    textAlign: 'center',
    display: 'block',
  },
  moreInfoText: {
    fontSize: '16px',
    fontFamily: 'circe-rounded',
    maxWidth: '70%',
    textAlign: 'center',
  },
  loadingContainer: {
    height: '98%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  loadingText: {
    position: 'relative',
    right: '65px',
    fontFamily: 'Lato',
  },
  button: {
    border: '2px solid #e0592a',
    color: 'black',
    fontSize: '11px',
    width: '100px',
    minHeight: '35px',
    fontFamily: 'Lato',
    borderRadius: '0px',
    boxShadow: 'none',
    alignSelf: 'center',
    margin: '5px 0px 15px 0px',
    padding: '0',
  },
  centeredItemsContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  inlineTitle: {
    display: 'inline',
    fontWeight: 600,
  },
  inlineValue: {
    display: 'inline',
  },
  orderStatusIcon: {
    fontSize: '15px',
    paddingRight: '5px',
  },
  smallerOrderStatusIcon: {
    fontSize: '12px',
    paddingRight: '5px',
  },
  orderStatusValueContainer: {
    display: 'inline-block',
  },
  underlinedInlineTitle: {
    display: 'inline',
    fontFamily: 'Lato',
    fontWeight: 600,
    textDecoration: 'underline',
  },
  applyButtonContainer: {
    margin: '10px 0px 10px 20px',
  },
  applyFiltersButton: {
    backgroundColor: customizedThemes.palette.primary.main,
    color: customizedThemes.palette.primary.white,
    height: '40px',
    borderRadius: '5',
    fontSize: '11px',
    fontFamily: 'Lato',
  },
  reprintButtonContainer: {
    width: '100%',
    marginTop: 2,
    marginBottom: 2,
    display: 'flex',
    justifyContent: 'right',
    alignItems: 'right',
  },
  reprintButton: {
    width: '120px',
    height: '40px',
    backgroundColor: '#e0592a',
    borderRadius: 5,
    margin: 2,
    display: 'flex',
    justifyContent: 'right',
    alignItems: 'right',
  },
  reprintButtonText: {
    fontFamily: 'Lato',
    paddingRight: 8,
    paddingLeft: 8,
    fontSize: 11,
    color: '#ffffff',
    textAlign: 'center',
  },
  checkbox: {
    paddingRight: '6px',
    color: customizedThemes.palette.primary.main,
  },
  menuItem: {
    paddingLeft: '8px',
  },
  locationButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '90%',
    margin: '1% 0 1% 10%',
  },
  locationButton: {
    backgroundColor: '#e0592a',
    border: 'none',
    color: '#ffffff',
    textTransform: 'none',
    marginRight: 3,
  },
  closeIcon: {
    paddingRight: 1,
  },
});

export const uploadImageStyle = theme => ({
  imageContainer: {
    position: 'relative',
    width: 'calc(100% - 64px)',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    paddingTop: '50px',
    paddingLeft: '32px',
    paddingRight: '32px',
    paddingBottom: '40px',
    minHeight: '290px',
  },
  imageStyle: {
    width: '100%',
    objectFit: 'cover',
    objectPosition: 'center',
  },
  imagePlaceholder: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#e7e7e7',
    boxShadow: 'none',
  },
  addPhotoButton: {
    minWidth: '113px',
    minHeight: '31px',
    backgroundColor: customizedThemes.palette.primary.black,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: customizedThemes.palette.primary.white,
    fontFamily: 'Lato',
    fontWeight: 'bold',
    fontSize: '12px',
    cursor: 'pointer',
  },
  hiddenChooseFile: {
    width: '0.1px',
    height: '0.1px',
    opacity: '0px',
    overflow: 'hidden',
    position: 'absolute',
    zIndex: '-1',
  },
  closeButton: {
    backgroundColor: customizedThemes.palette.primary.main,
    color: customizedThemes.palette.primary.white,
    width: '30px',
    height: '30px',
    padding: '0',
    position: 'absolute',
    top: '5%',
    right: '8%',
  },
});

export const displayImageStyle = theme => ({
  multipleImageContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
    height: '100%',
  },
});

export const hourStyle = theme => ({
  hoursContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'center',
    height: '50px',
  },
  hoursContainerWithRedBorder: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'center',
    height: '50px',
    border: '1px solid red',
  },
  hoursInfoContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  infoIcon: {
    ...infoIcon,
  },
  dayInWeekText: {
    fontFamily: 'Lato',
    fontSize: '14px',
    width: '90px',
    textAlign: 'right',
  },
  dayInWeekTextDisabled: {
    fontFamily: 'Lato',
    fontStyle: 'italic',
    fontSize: '14px',
    width: '90px',
    textAlign: 'right',
    color: '#9b9b9b',
  },
  timeInputContainer: {
    display: 'flex',
    flexDirection: 'row',
    paddingLeft: 10,
    alignItems: 'center',
  },
  checkboxContainer: {
    margin: '0',
    width: '120px',
  },
  addHourLink: {
    textDecoration: 'underline',
    cursor: 'pointer',
    margin: '10px 0',
    color: customizedThemes.palette.primary.main,
    width: '60px',
  },
  dashInbetween: {
    padding: '10px 10px 10px 10px',
  },
  inputProps: {
    step: 300, // 5 min
    style: {
      fontSize: '15px',
      fontFamily: 'Lato',
    },
  },
  inputLabelProps: {
    shrink: true,
  },
  textField: {
    height: '35px',
  },
  checkBoxLabel: {
    fontFamily: 'Lato',
    width: '60px',
  },
  sectionTitle: {
    fontFamily: 'Lato',
    fontWeight: 'bold',
    padding: '12px',
  },
  tabAppBar: {
    width: '700px',
    boxShadow: 'none',
    paddingLeft: '12px',
    backgroundColor: customizedThemes.palette.primary.white,
  },
  tabHeader: {
    fontFamily: 'Lato',
    textTransform: 'none',
  },
  tabWithError: {
    fontFamily: 'Lato',
    textTransform: 'none',
    border: '1px red solid',
  },
  tabContentContainer: {
    border: 'none',
    backgroundColor: customizedThemes.palette.primary.white,
    borderRadius: '0 0 8px 8px',
    padding: '10px 10px 20px 10px',
  },
  sameAsOpeningHoursContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  sameAsOpeningHoursText: {
    fontSize: '14px',
    fontFamily: 'Lato',
  },
  checkBoxColor: {
    color: '#000',
  },
  emptyDiv: {
    height: '25px',
  },
  timePickerWidth: {
    width: '125px',
  },
  timePickerLikeDiv: {
    height: '32px',
    width: '125px',
  },
  trashCanIcon: {
    fontSize: '24px',
    margin: '0 0 0 11px',
  },
  helperText: {
    marginTop: '2px',
  },
});

export const dropDownStyle = theme => ({
  formControlStyle: {
    width: '100.4%',
  },
  noMarginFormControlStyle: {
    margin: '0',
    width: '100%',
  },
  orderStatusFilterRightSpacer: {
    width: '24px',
  },
  dropDownItem: {
    fontFamily: 'Lato',
  },
  v2ToolbarDropdownItem: {
    fontFamily: 'Lato',
    fontStyle: 'italic',
  },
  disabledDropDownItem: {
    backgroundColor: 'black',
    color: 'white',
  },
  placeholderOptionText: {
    fontFamily: 'Lato',
  },
  displayValueText: {
    height: '20px',
    width: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
});

const dialogContainer = {
  padding: '0',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'relative',
};

export const forgotPasswordDialogs = theme => ({
  dialogContainer: {
    ...dialogContainer,
    width: '500px',
  },
  dialogContainerMobile: {
    ...dialogContainer,
    width: '275px',
  },
  closeButtonStyle: {
    color: customizedThemes.palette.primary.black,
    width: '50px',
    position: 'absolute',
    right: '2%',
    marginTop: '5px',
  },
  topImage: {
    padding: '60px 50px 20px 50px',
  },
  dialogTitle: {
    fontFamily: 'Lato',
    fontSize: '25px',
    fontWeight: 'bold',
    paddingBottom: '20px',
  },
  dialogDescription: {
    fontFamily: 'Lato',
    fontSize: '18px',
    textAlign: 'center',
    marginLeft: '15px',
    marginRight: '15px',
  },
  inputTextField: {
    width: '100%',
    color: customizedThemes.palette.primary.black,
    marginTop: '40px',
  },
  inputTextFieldTablet: {
    width: '100%',
    color: customizedThemes.palette.primary.black,
    marginTop: '20px',
  },
  bottomButton: {
    backgroundColor: customizedThemes.palette.primary.main,
    width: '85%',
    height: '50px',
    color: customizedThemes.palette.primary.white,
    fontFamily: 'Lato',
    borderRadius: '0',
    marginTop: '50px',
    fontSize: '18px',
  },
  tokenBoxContainer: {
    marginTop: '20px',
  },
  tokenBox: {
    width: '56px',
    height: '46px',
    margin: '5px',
    border: '2px solid',
    padding: '0',
  },
  errorTextStyle: {
    color: 'red',
    fontFamily: 'Lato',
    fontSize: '15px',
    textAlign: 'center',
    width: '60%',
    padding: '10px 0',
  },
});

export const filterComponentStyles = theme => ({
  filterContainer: {
    display: 'flex',
    alignItems: 'center',
    margin: '10px 0 10px 0px',
  },
  v2DropdownContainer: v2DropdownStyleInstance.dropdownOuterContainer,
  filterDropdown: {
    minWidth: '100px',
    border: '1px solid #979797',
    borderRadius: '8px',
    height: '45px',
    paddingLeft: '10px',
    fontFamily: 'Lato',
  },
});

const baseSearchContainer = {
  display: 'flex',
  flexDirection: 'row',
  minWidth: '250px',
  maxHeight: '43px',
};

export const searchComponentStyles = theme => ({
  searchContainer: baseSearchContainer,
  widerSearchContainer: {
    ...baseSearchContainer,
    minWidth: '300px',
    margin: '10px 20px 10px 0',
  },
  bigContainer: {
    width: '50%',
  },
  textFieldStyle: {
    borderRadius: '0px 5px 5px 0px',
    border: '1px solid #000000',
    borderLeft: 'none',
    width: '80%',
    display: 'flex',
    justifyContent: 'center',
    fontSize: '14px',
    backgroundColor: customizedThemes.palette.primary.white,
  },
  inputStyle: {
    fontSize: '14px',
  },
  searchButton: {
    width: '42px',
    height: '43px',
    borderTopRightRadius: '0%',
    borderBottomRightRadius: '0%',
    borderTopLeftRadius: '10%',
    borderBottomLeftRadius: '10%',
    border: '1px solid #000000',
    borderRight: 'none',
    color: '#282828',
    fontSize: '14px',
    fontFamily: 'Lato',
    backgroundColor: customizedThemes.palette.primary.white,
  },
  searchIcon: {
    fontSize: '20px',
  },
  clearLinkContainer: {
    display: 'flex',
    alignItems: 'flex-end',
  },
  clearSearchLink: {
    fontSize: '12px',
    fontStyle: 'italic',
    marginLeft: '6px',
    marginRight: '12px',
    color: customizedThemes.palette.primary.main,
    cursor: 'pointer',
  },
});

export const userPageStyle = theme => ({
  searchableControlSingleOverride: {
    width: '90%',
  },
  searchableControlMultiOverride: {
    width: '90%',
    maxHeight: '48px',
    overflowY: 'auto',
  },
  multiValueLabelOverride: {
    maxWidth: '15vw',
  },
  clearIndicatorOverride: {
    padding: '0',
    alignSelf: 'flex-start',
    position: 'sticky',
    top: '2%',
  },
  dropdownIndicatorOverride: {
    padding: '0 4px 0 0',
    alignSelf: 'flex-start',
    position: 'sticky',
    top: '2%',
  },
  filterContainer: {
    margin: '2% 2% 0 2%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    padding: '4px',
    width: '94%',
  },
  filterTitleContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignSelf: 'stretch',
    margin: '20px 0 0 0',
  },
  filterTitleContainerMobile: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    margin: '20px 0 0 -13px',
  },
  filterTitle: {
    fontFamily: 'Lato',
    fontSize: '20px',
  },
  searchBox: {
    width: '90%',
    border: '1px solid #979797',
    borderRadius: '8px',
    height: '35px',
    fontFamily: 'Lato',
    margin: '15px 0 0 5px',
    padding: '5px 0 0 5px',
  },
  filterRowContainer: {},
  filterColumnContainer: {},
  dropdownFilterContainer: {
    display: 'flex',
    flexDirection: 'row',
    minWidth: '80px',
    alignItems: 'center',
    height: '100%',
  },
  neverOrderedContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'right',
    height: '100%',
    paddingLeft: '5px',
  },
  pointsSearchBoxContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: '100%',
    margin: '0 10px 0 5px',
    width: '92%',
  },
  pointsSearchbox: {
    width: '20%',
    border: '1px solid #979797',
    borderRadius: '8px',
    height: '35px',
    fontFamily: 'Lato',
    margin: '0',
    padding: '5px 0 0 5px',
  },
  pointsSearchboxError: {
    width: '20%',
    border: '1px solid #979797',
    borderRadius: '8px',
    height: '35px',
    fontFamily: 'Lato',
    margin: '0',
    padding: '5px 0 0 5px',
    borderColor: 'red',
  },
  applyFilterButtonContainer: {
    height: '100%',
    minWidth: '100px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  applyFilterButton: {
    minWidth: '50px',
    height: '40px',
    color: customizedThemes.palette.primary.white,
    backgroundColor: customizedThemes.palette.primary.black,
    borderRadius: '0',
    fontFamily: 'Lato',
  },
  lastOrderFont: {
    fontFamily: 'Lato',
    width: '50%',
    margin: '5px 5px 5px 0',
    fontSize: 12,
    textAlign: 'right',
  },
  noOrderFont: {
    fontFamily: 'Lato',
    width: '60%',
    margin: '10px 5px 5px 0',
    fontSize: 12,
    textAlign: 'right',
  },
  neverOrderedFont: {
    fontFamily: 'Lato',
    width: '50%',
    margin: '10px 5px 5px 5px',
    fontSize: 12,
    textAlign: 'right',
  },
  lastOrderLocationFont: {
    fontFamily: 'Lato',
    width: '50%',
    margin: '5px 5px 5px 5px',
    fontSize: 12,
  },
  hasOrderedCategoryFont: {
    fontFamily: 'Lato',
    width: '50%',
    margin: '5px 5px 5px 5px',
    fontSize: 12,
    textAlign: 'right',
  },
  hasOrderedProductFont: {
    fontFamily: 'Lato',
    width: '50%',
    margin: '5px 5px 5px 5px',
    fontSize: 12,
    textAlign: 'right',
  },
  minPointsFont: {
    fontFamily: 'Lato',
    width: '50%',
    margin: '0 5px 5px 0',
    fontSize: 12,
  },
  maxPointsFont: {
    fontFamily: 'Lato',
    width: '50%',
    margin: '0 5px 5px 5px',
    fontSize: 12,
    textAlign: 'center',
  },
  paper: {
    margin: '2% 2% 3% 2%',
    width: '94%',
    height: '65%',
    overflowX: 'hidden',
    overflowY: 'auto',
  },
});

export const reportsPageStyle = theme => ({
  container: {
    margin: '1% 2%',
    display: 'flex',
    minWidth: '94%',
  },
  selectLocationFont: {
    fontFamily: 'Lato',
    fontSize: 15,
    margin: '1% 2% 1% 0%',
    flexGrow: 2,
  },
  searchableSelect: {
    position: 'relative',
    flexGrow: 1,
    width: 'auto',
  },
});

export const CraverRadioStyle = theme => ({
  CraverRadioStyle: {
    display: 'flex',
    flexDirection: 'row',
    width: '150px',
    paddingTop: '15px',
  },
  CraverRadioStyleNoPadding: {
    display: 'flex',
    flexDirection: 'row',
    width: '150px',
    paddingTop: '0px',
  },
  formControlLabelMobile: {
    marginRight: '6px',
  },
  craverRadioMobile: {
    paddingRight: '6px',
  },
});
export const menuDrawerStyle = theme => ({
  drawerOpen: {
    width: '200px',
    backgroundColor: customizedThemes.palette.primary.light,
    overflowX: 'hidden',
    overflowY: 'auto',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    width: '70px',
    backgroundColor: customizedThemes.palette.primary.light,
    overflowX: 'hidden',
    overflowY: 'auto',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  greySubMenuCollapse: {
    width: '100%',
    backgroundColor: customizedThemes.palette.primary.white,
  },
  blackSubMenuCollapse: {
    width: '100%',
    backgroundColor: customizedThemes.palette.primary.white,
  },
  subMenuListItemText: {
    flex: 1,
    paddingLeft: '65px',
  },
  menuIcon: {
    color: customizedThemes.palette.primary.main,
  },
  openDrawerIcon: {
    zIndex: '5',
    height: '50px',
    marginLeft: '3%',
    padding: '0',
    position: 'absolute',
    marginTop: '-20px',
  },
});

export const variationComponentStyles = theme => ({
  paper: {
    margin: '0 2.5% 2% 2.5%',
    width: '99%',
  },
  headingText: {
    fontFamily: 'circe-rounded',
    fontSize: '24px',
    color: customizedThemes.palette.primary.black,
    alignSelf: 'start',
    marginLeft: '2%',
    fontWeight: 'bold',
  },
  fieldContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    padding: '1%',
    width: '100%',
    margin: '0px 2px',
  },
  textFieldStyle: {
    border: '1px solid #979797',
    borderRadius: '8px',
    width: '100%',
    background: customizedThemes.palette.primary.white,
    paddingLeft: '10px',
    fontFamily: 'Lato',
  },
  priceFieldStyle: {
    border: '1px solid #979797',
    borderRadius: '8px',
    width: '30%',
    background: customizedThemes.palette.primary.white,
    paddingLeft: '10px',
    fontFamily: 'Lato',
  },
  radioStyle: {
    marginTop: '5px',
    width: '20px',
    height: '20px',
    color: customizedThemes.palette.primary.main,
  },
  addVariationButtonContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    height: '50px',
    paddingTop: '15px',
  },
  addVariationButton: {
    backgroundColor: '#e0592a',
    color: customizedThemes.palette.primary.white,
    fontSize: '11px',
    minWidth: '140px',
    height: '35px',
    fontFamily: 'Lato',
    borderRadius: '5px',
    boxShadow: 'none',
    marginRight: '1%',
  },
  applyChangesButtonContainer: {
    width: '94%',
    display: 'flex',
    justifyContent: 'flex-end',
    paddingBottom: '2%',
  },
  applyChangesButton: {
    width: '200px',
    height: '50px',
    borderRadius: '0',
    backgroundColor: customizedThemes.palette.primary.main,
    color: customizedThemes.palette.primary.white,
    fontFamily: 'Lato',
    fontSize: '12px',
    fontWeight: 'bold',
  },
  errorMessage: {
    color: 'red',
  },
  errorTextField: {
    border: '1px solid red',
    borderRadius: '8px',
    width: '100%',
    background: customizedThemes.palette.primary.white,
    paddingLeft: '10px',
    fontFamily: 'Lato',
  },
  errorPriceField: {
    border: '1px solid red',
    borderRadius: '8px',
    width: '30%',
    background: customizedThemes.palette.primary.white,
    paddingLeft: '10px',
    fontFamily: 'Lato',
  },
});

export const variationStylesForWithStylesHOC = {
  root: {
    verticalAlign: 'top',
    borderBottom: 'none',
  },
  default: {
    borderBottom: 'none',
  },
};

const messageBase = {
  fontFamily: 'Lato',
  fontSize: '14px',
  textAlign: 'center',
};

export const generalDialogStyles = theme => ({
  bulkActionDialogContainer: {
    position: 'relative',
    minHeight: '475px',
    width: '500px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0',
  },
  messageAndTargetResourcesContainer: {
    width: '80%',
  },
  bulkActionAreYouSureQuestion: {
    ...messageBase,
    paddingTop: '20px',
  },
  generalMessage: {
    ...messageBase,
    padding: '20px',
  },
  bottomButtonsContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'center',
    margin: '0 0 50px 0',
  },
  truncatedBulkTargetResourceName: {
    marginBottom: '5px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  taxActionDialogContainer: {
    position: 'relative',
    height: 'auto',
    width: '445px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0',
  },
  taxActionDialogTitle: {
    fontFamily: 'Lato',
    fontWeight: 'bold',
    fontSize: '20px',
    marginTop: '14px',
  },
  taxActionDialogIcon: {
    color: customizedThemes.palette.primary.grey,
    fontSize: '49px',
    marginTop: '10px',
  },
  taxActionDialogText: {
    fontFamily: 'Lato',
    fontSize: '14px',
    margin: '15px 30px',
    textAlign: 'center',
  },
  taxActionDialogButtonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '300px',
    marginBottom: '30px',
  },
});

export const advancedProductDialogStyles = theme => ({
  advancedProductDialogContainer: {
    position: 'relative',
    height: '731px',
    width: '755px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0',
  },
  fieldsContainer: {
    width: '626px',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  fieldContainer: {
    width: '300px',
    minHeight: '104px',
    display: 'flex',
    flexDirection: 'column',
  },
  closeButton: {
    position: 'absolute',
    width: '50px',
    right: '2%',
    top: '5px',
    color: customizedThemes.palette.primary.black,
  },
  dialogImage: {
    marginTop: '70px',
  },
  dialogTitle: {
    fontFamily: 'Lato',
    fontSize: '25px',
    fontWeight: 'bold',
    paddingBottom: '20px',
    marginTop: '34.5px',
    marginBottom: '33.5px',
  },
  fieldTitleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '300px',
  },
  fieldTitle: {
    fontFamily: 'Lato',
    fontWeight: 'bold',
  },
  dialogDropdown: {
    width: '288px',
    height: '40px',
    borderRadius: '8px',
    paddingLeft: '10px',
    border: '1px solid #979797',
    background: customizedThemes.palette.primary.white,
    fontFamily: 'Lato',
  },
  errorDropdown: {
    width: '288px',
    height: '40px',
    borderRadius: '8px',
    paddingLeft: '10px',
    border: '1px solid red',
    background: customizedThemes.palette.primary.white,
    fontFamily: 'Lato',
  },
  errorMessage: {
    color: 'red',
  },
  textFieldStyle: {
    width: '288px',
    height: '31px',
    border: '1px solid #979797',
    borderRadius: '8px',
    background: customizedThemes.palette.primary.white,
    paddingTop: '2px',
    paddingBottom: '7px',
    paddingLeft: '10px',
    fontFamily: 'Lato',
    marginTop: '1em',
  },
  saveButton: {
    backgroundColor: customizedThemes.palette.primary.main,
    color: customizedThemes.palette.primary.white,
    width: '626px',
    height: '40px',
    borderRadius: '0',
    fontFamily: 'Lato',
    fontSize: '12px',
    marginTop: '27px',
    marginBottom: '51px',
  },
});

const bulkTargetResourcesBase = {
  fontFamily: 'Lato',
  fontWeight: 'bold',
  fontSize: '16px',
  whiteSpace: 'pre-wrap',
  margin: '40px 30px 40px 30px',
  overflow: 'auto',
  minHeight: '20px',
  maxHeight: '145px',
  textAlign: 'center',
};

export const deleteConfirmationDialogStyles = theme => ({
  deleteConfirmationDialogContainer: {
    position: 'relative',
    height: '450px',
    width: '500px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0',
  },
  deleteConfirmationDialogContainerTablet: {
    position: 'relative',
    height: '410px',
    width: '430px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0 0 20px',
    border: 'solid 1px grey',
    borderRadius: '0',
  },
  closeButton: {
    position: 'absolute',
    width: '50px',
    right: '2%',
    top: '5px',
    color: customizedThemes.palette.primary.black,
  },
  dialogImage: {
    marginTop: '50px',
  },
  dialogTitle: {
    fontFamily: 'Lato',
    fontSize: '25px',
    fontWeight: 'bold',
    paddingBottom: '20px',
    marginTop: '20px',
  },
  dialogDescription: {
    fontFamily: 'Lato',
    fontSize: '14px',
    paddingBottom: '40px',
  },
  cancelOrderDialogDescription: {
    fontFamily: 'Lato',
    fontWeight: 'bold',
    fontSize: '14px',
    paddingBottom: '20px',
  },
  dataToBeDeleted: {
    fontFamily: 'Lato',
    fontWeight: 'bold',
    fontSize: '18px',
    padding: '0 0 40px 0',
    textAlign: 'center',
  },
  bulkTargetResources: bulkTargetResourcesBase,
  bulkTargetResourcesWithVertScrollbar: {
    ...bulkTargetResourcesBase,
    width: '355px',
  },
  confirmButton: {
    backgroundColor: customizedThemes.palette.primary.main,
    color: customizedThemes.palette.primary.white,
    width: '200px',
    height: '40px',
    borderRadius: '0',
    fontFamily: 'Lato',
    fontSize: '12px',
  },
  cancelText: {
    fontFamily: 'Lato',
    fontStyle: 'italic',
    textDecoration: 'underline',
    marginTop: '20px',
    textAlign: 'center',
  },
});

export const editorDialogStyle = theme => ({
  dialogContent: {
    height: '500px',
    width: '1000px',
  },
});

export const CollapsibleItemStyle = theme => ({
  expandIconContainer: {
    position: 'absolute',
    right: '-10px',
    top: '50%',
    width: '5%',
    display: 'flex',
    justifyContent: 'space-evenly',
  },
  collapseContainer: {
    width: '98%',
    position: 'relative',
    margin: '5px 2px',
  },
  collapsedView: {
    position: 'relative',
  },
});

export const nestedAddressStyle = theme => ({
  addressContainer: {
    width: '98%',
    position: 'relative',
    margin: '5px 2px',
    display: 'flex',
    textTransform: 'capitalize',
  },
});

export const notificationDialogStyle = theme => ({
  notificationDialogContainer: {
    position: 'relative',
    height: '570px',
    width: '500px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0',
  },
  closeButton: {
    position: 'absolute',
    width: '50px',
    right: '2%',
    top: '5px',
    color: customizedThemes.palette.primary.black,
  },
  dialogImage: {
    marginTop: '50px',
  },
  dialogTitle: {
    fontFamily: 'Lato',
    fontSize: '25px',
    fontWeight: 'bold',
    marginBottom: '10px',
    marginTop: '20px',
  },
  dialogContentContainer: {
    width: '370px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  dialogSubTitle: {
    fontFamily: 'Lato',
    fontSize: '14px',
    marginBottom: '0px',
  },
  maximumCharacterContainer: {
    width: '370px',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  maximumCharacterText: {
    fontFamily: 'Lato',
    fontSize: '14px',
  },
  maximumCharacterTextCloseToLimit: {
    fontFamily: 'Lato',
    fontSize: '14px',
    color: '#FF9069',
  },
  maximumCharacterTextLimit: {
    fontFamily: 'Lato',
    fontSize: '14px',
    color: '#F73535',
  },
  notificationTitleTextBox: {
    width: '350px',
    height: '40px',
    border: '1px solid #8b8b8b',
    borderRadius: '5px',
    marginBottom: '0px',
    marginTop: '20px',
    padding: '0 10px 0 10px',
  },
  notificationTitleInputProps: {
    style: {
      fontFamily: 'Lato',
      textAlign: 'left',
      padding: '0',
      marginTop: '10px',
    },
  },
  notificationBodyTextBox: {
    width: '350px',
    height: '100px',
    border: '1px solid #8b8b8b',
    padding: '10px',
    borderRadius: '5px',
    marginBottom: '0px',
    marginTop: '20px',
  },
  notificationBodyInputProps: {
    style: {
      fontFamily: 'Lato',
      textAlign: 'left',
    },
  },
  confirmButton: {
    backgroundColor: customizedThemes.palette.primary.main,
    color: customizedThemes.palette.primary.white,
    width: '370px',
    height: '40px',
    borderRadius: '0',
    fontFamily: 'Lato',
    fontSize: '12px',
    marginTop: '20px',
  },
  cancelText: {
    fontFamily: 'Lato',
    fontStyle: 'italic',
    textDecoration: 'underline',
    marginTop: '20px',
  },
  doneIcon: {
    width: '50px',
    height: '50px',
    color: '#03b400',
    fontSize: '50px',
  },
});

export const orderDetailBoxStyle = theme => ({
  boxContainer: {
    padding: '20px',
    margin: '20px 20px 20px 0',
    border: '2px solid black',
    height: '90%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    overflow: 'auto',
  },
  itemTitleAndPriceContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  customizationText: {
    color: '#8b8b8b',
    fontStyle: 'italic',
  },
  subtitleText: {
    color: '#8b8b8b',
  },
});

export const loadingSkeletonStyle = theme => ({
  chartSkeletonLineSpacer: {
    height: '5%',
    marginBottom: '2%',
  },
  fullWidthWrapperToEnsureShowsUp: {
    width: '100%',
  },
});

export const heightlessTextFieldFormControlBase = {
  borderRadius: '8px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '0 10px',
};
export const textFieldFormControlBase = {
  ...heightlessTextFieldFormControlBase,
  height: '36px',
};
const submitButtonBase = {
  padding: '0',
  fontSize: '11px',
  height: '40px',
  width: '305px',
  fontFamily: 'Lato',
  borderRadius: '5px',
  boxShadow: 'none',
};
export const createEditOptionDialogStyles = theme => ({
  dialogPaper: {
    padding: '30px',
    position: 'relative',
  },
  dialogHeaderParent: {
    minHeight: '34px',
    margin: '0 0 30px 0',
  },
  dialogTitleSection: {
    color: '#000000',
    fontFamily: 'Lato',
    fontWeight: '400',
    fontSize: '28px',
  },
  closeIconSection: {
    position: 'absolute',
    top: 0,
    right: 0,
    height: '60px',
    width: '60px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  closeButton: {
    color: '#000000',
  },
  textFieldFormControl: {
    ...textFieldFormControlBase,
    border: '1px solid #979797',
  },
  errorBorder: {
    ...textFieldFormControlBase,
    border: '1px solid red',
  },
  textFieldMuiInput: {
    width: '100%',
  },
  validationError: {
    color: 'red',
  },
  searchableParent: {
    margin: '30px 0 0 0',
  },
  submitGridContainer: {
    padding: '40px 0 12px 0',
  },
  submitButton: {
    ...submitButtonBase,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.white,
    '&:hover': {
      backgroundColor: '#ff875e',
      color: theme.palette.primary.white,
    },
  },
  disabledSubmitButton: {
    ...submitButtonBase,
    backgroundColor: '#cbcbcb',
    color: theme.palette.primary.white,
  },
});
